const channelCode = process.env.NEXT_PUBLIC_SYLIUS_CHANNEL_CODE;

export const DefaultPlaceholder: string = "/images/pages/placeholder.png";
export const DefaultBeer: string = "/images/pages/product-default-beer.png"; //beer
export const DefaultCigar: string = "/images/pages/product-default-cigar.png"; //cigars
export const DefaultFood: string = "/images/pages/product-default-food.png"; //foods
export const DefaultLiquor: string = "/images/pages/product-default-liquors.png"; //spirits
export const DefaultWine: string = "/images/pages/product-default-wine.png"; //wine
export const DefaultGifts: string = 
  channelCode === "SPECS" 
    ? "/images/pages/product-default-specs-gifts.png" 
    : "/images/pages/product-default-gifts.png"; // gifts

export const getDefaultImageForProduct = (type: string) => {
  switch (type) {
    case "beer":
      return DefaultBeer;
    case "cigars":
      return DefaultCigar;
    case "foods":
      return DefaultFood;
    case "gifts":
      return DefaultGifts;
    case "spirits":
      return DefaultLiquor;
    case "wine":
      return DefaultWine;
    default:
      return DefaultPlaceholder;
  }
};
